import { writable } from 'svelte/store';

export const scanState = writable({
  status: 'idle',
  lastScanAt: null,
  queuedChannels: 0,
  processedChannels: 0,
  quotaRemaining: 9600,
  recentEvents: []
});

export function addScanEvent(event) {
  scanState.update((state) => ({
    ...state,
    recentEvents: [
      { id: crypto.randomUUID(), message: event, createdAt: new Date().toISOString() },
      ...state.recentEvents
    ].slice(0, 6)
  }));
}

export function setScanStatus(status) {
  scanState.update((state) => ({ ...state, status }));
}

export function setScanProgress({ queuedChannels, processedChannels }) {
  scanState.update((state) => ({
    ...state,
    queuedChannels,
    processedChannels
  }));
}

export function setLastScanAt(value) {
  scanState.update((state) => ({ ...state, lastScanAt: value }));
}
